interface ParseColumnIdArgs {
  columnId: string
  rootEntity: string
}

interface ParsedColumnId {
  entity: string
  field: string
}

export function parseColumnId({
  columnId,
  rootEntity,
}: ParseColumnIdArgs): ParsedColumnId {
  const separatorIndex = columnId.indexOf('.')

  if (separatorIndex > 0) {
    return {
      entity: columnId.slice(0, separatorIndex),
      field: columnId.slice(separatorIndex + 1),
    }
  }

  return {
    entity: rootEntity,
    field: columnId,
  }
}
